module.exports = __webpack_public_path__ + "img/EnManageSys.9fbe91fb.jpg";